import { CompanyCellData } from 'src/store/clients/types';

export const companyCellComparator = (
  a: CompanyCellData[],
  b: CompanyCellData[],
) => {
  if (a.at(0)?.isPlaceholder) {
    return 1;
  }
  if (b.at(0)?.isPlaceholder) {
    return -1;
  }
  return a
    .map((c) => c.name)
    .join(', ')
    .localeCompare(b.map((c) => c.name).join(', '));
};

/**
 * Checks if a company has a temporary ID (optimistic company)
 * @param companyId - The company ID to check
 * @returns true if the company has a temporary ID, false otherwise
 */
export const isTemporaryCompanyId = (companyId: string): boolean => {
  return companyId.startsWith('temp-');
};

/**
 * Checks if a company is in a temporary/optimistic state
 * @param company - The company object to check
 * @returns true if the company is temporary, false otherwise
 */
export const isTemporaryCompany = (company: { id: string }): boolean => {
  return isTemporaryCompanyId(company.id);
};
